export default __webpack_public_path__ + "static/media/support_service.41ddd394.svg";